import React, { useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { useInfiniteResults } from '@uncinc/react-searchkit';
import type { BaseHit, InfiniteResults, Hit } from '@uncinc/react-searchkit/types';

import './style.scss';

interface SearchResult extends Hit<BaseHit> {
  id: string[],
  computed_first_upcoming_start_date: [string],
  start_date: [number],
  date: Date,
}

interface IDictionary<TValue> {
  [id: string]: TValue;
}

const SearchResultsGroupedInfinite: React.FC<InfiniteResults> = (props) => {
  const { t } = useTranslation();

  const {
    renderItem,
    showMoreButtonText = t('searchkit.buttons.show_more'),
    autoScroll,
    className,
  } = props;

  const sentinelRef = useRef(null);
  const { hits, isLastPage, showMore } = useInfiniteResults(sentinelRef, autoScroll);

  const classNames = c('SearchResultsGroupedInfinite', className);

  const months: IDictionary<SearchResult[]> = {};
  hits.forEach((_hit: Hit<BaseHit>) => {
    const hit = _hit as SearchResult;

    // eslint-disable-next-line @typescript-eslint/no-loop-func
    hit.start_date?.forEach((recurringDate) => {
      const date = new Date(recurringDate * 1000);

      const dateMonth = new Date(date);
      dateMonth.setDate(1);
      dateMonth.setHours(0);
      dateMonth.setMinutes(0);
      dateMonth.setSeconds(0);
      dateMonth.setMilliseconds(0);

      // const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const key = dateMonth.toISOString();
      if (!months[key]) {
        months[key] = [];
      }

      const newHit: SearchResult = { ...hit };
      newHit.date = date;

      const contains = months[key]?.reduce((acc, item) => {
        if (
          item.objectID === newHit.objectID &&
          item.date.toString() === newHit.date.toString()
        ) {
          return true;
        }

        return acc;
      }, false);

      if (!contains) {
        months[key]?.push(newHit);
      }
    });
  });

  return (
    <div className={classNames}>
      {Object.keys(months).sort().map((d) => {
        const date = new Date(d);
        return (
          <div className="SearchResultsGroupedInfinite__group">
            <div className="SearchResultsGroupedInfinite__group__date">
              <h3>{date.toLocaleString('default', { month: 'long' })} {date.getFullYear()}</h3>
            </div>
            <div className="SearchResultsGroupedInfinite__group__events">
              {
                months[d]?.map((hit) => renderItem(hit))
              }
            </div>
          </div>
        );
      })}

      {(hits.length > 0 && !isLastPage) && (
        <button
          type="button"
          className="Searchkit__SearchResultsGroupedInfinite__showMore"
          onClick={() => {
            showMore();
          }}
        >
          {showMoreButtonText}
        </button>
      )}
    </div>
  );
};

export default SearchResultsGroupedInfinite;
